export default function adaptiveCssFromRef(refElement) {
  let AdaptiveHeightComponent = 0

  AdaptiveHeightComponent = window.innerHeight - refElement?.current?.clientHeight

  return AdaptiveHeightComponent;
}